import JWTinterceptor  from "@/services/axios";

export async function getPatientsService(page){
    try {
        const response = await JWTinterceptor.post(`get_patients/${page}/`);
        return response.data.data;   
    } catch(err){
        console.error("Get patients Error:",err);
        throw err;
    }
}

export async function getPatientByIdService(patientId) {
  try {
    const res = await JWTinterceptor.post(`get_patient_by_id`,
      {
        patient_id: patientId,
      }
    );
    return res.data.data;

  } catch (err) {
    console.error("Get patient by ID error:", err);
    throw err; 
  }
}

export async function addPatientService(patientData) {
  try {
    const res = await JWTinterceptor.post(`add_patient`,
      patientData
    );
    const created = res.data?.data || res.data;

    return created;
  } catch (err) {
    console.error("Add patient error:", err);
    throw err; 
  }
}

export async function updatePatientService(patientId, updateFields) {
  try {
    const res = await JWTinterceptor.patch(`update_patient`,
    {
        patient_id: patientId,
        update_fields: updateFields
      }
    );
    return res.data;
  } catch (err) {
    console.error("Update patient error:", err);
    throw err; 
  }
}
export async function searchPatientService(query) {
  try {
    const response = await JWTinterceptor.post(`get_patients_list`,
      {
        phone_number: query,
      }
    );

    const list = response?.data?.data ?? response?.data ?? [];
    return Array.isArray(list) ? list : [];

  } catch (err) {
    console.error("Search phone error:", err);
    throw err; 
  }
}
